import { Container, Denominator, Divider, Numerator } from './Fraction.style';

interface FractionProps {
  numerator: number | string;
  denominator: number | string;
}

const Fraction = ({ denominator, numerator }: FractionProps) => (
  <Container>
    <Numerator>{numerator}</Numerator>
    <Divider />
    <Denominator>{denominator}</Denominator>
  </Container>
);

export default Fraction;
